<section class="panel activity-panel" aria-labelledby="activity-heading">
  <div class="section-heading">
    <div>
      <p class="eyebrow">PUBLIC EVENT LOG</p>
      <h2 id="activity-heading">Activity</h2>
    </div>
    <span class="quiet-status">{{ matching().length }} events</span>
  </div>

  <div class="toolbar">
    <div class="chips" role="group" aria-label="Filter by event type">
      @for (option of filters; track option.value) {
        <button
          type="button"
          class="chip"
          [class.active]="filter() === option.value"
          [attr.aria-pressed]="filter() === option.value"
          (click)="setFilter(option.value)"
        >
          {{ option.label }}
        </button>
      }
    </div>
  </div>

  @for (group of days(); track group.day) {
    <h3 class="day">{{ group.day | date: "fullDate" }}</h3>
    <ul class="activity-list" role="list">
      @for (event of group.events; track event.event_id) {
        @let info = describe(event);
        <li>
          <span
            class="event-icon"
            [class.revoked]="event.event_type === 'certificate_revoked'"
            aria-hidden="true"
            ><mat-icon>{{ info.icon }}</mat-icon></span
          >
          <span class="activity-copy">
            <strong>{{ info.label }} {{ info.action }}</strong>
            <span>
              <button
                type="button"
                class="link-button inline"
                (click)="openWrp.emit(event.wrp_id)"
              >
                {{ info.name }}
              </button>
              @if (info.subject && info.subject !== info.name) {
                · {{ info.subject }}
              }
            </span>
            @if (info.reason) {
              <small>Reason: {{ info.reason }}</small>
            }
            @if (info.status) {
              <small>Status: {{ info.status }}</small>
            }
            @if (info.replacement) {
              <small class="replacement">{{ info.replacement }}</small>
            }
            @if (info.fingerprint) {
              <small class="mono">{{ info.fingerprint }}</small>
            }
          </span>
          @if (info.record; as record) {
            <button
              type="button"
              class="icon-button"
              title="Decoded certificate"
              aria-label="Decoded certificate"
              (click)="inspect(record)"
            >
              <mat-icon aria-hidden="true">article</mat-icon>
            </button>
          }
          <span class="activity-meta">
            <a
              class="mono"
              [href]="eventLink(event)"
              target="_blank"
              rel="noopener"
              >#{{ event.sequence_number }}</a
            >
            <small>{{ event.published_at | date: "shortTime" }}</small>
          </span>
        </li>
      }
    </ul>
  } @empty {
    <div class="empty-state">
      <mat-icon>history</mat-icon>
      <h3>No events</h3>
      <p>The log has no events of this type yet.</p>
    </div>
  }

  @if (matching().length > limit()) {
    <div class="more">
      <button type="button" class="chip" (click)="showMore()">
        Show
        {{
          matching().length - limit() < 50 ? matching().length - limit() : 50
        }}
        more
      </button>
    </div>
  }
</section>
